import {Tire} from "../models/tire";

export function tireDescription(tire: Partial<Tire>){
    let infos = '';
    if (tire.width && tire.ratio && tire.diameter) {
        infos += `${tire.width}/${tire.ratio}R${tire.diameter} `;
    }

    return infos.concat([tire.loadIndex, tire.speedIndex].join(''));
}